<template>
  <div style="margin-bottom: 10px">
    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>累充金额奖励</span>
        <el-button
          style="float: right"
          type="primary"
          icon="el-icon-plus"
          @click="openDialog(true, null)"
          >新增累充金额奖励</el-button
        >
      </div>
      <el-table
        :data="data"
        border
        size="small"
        style="width: 571px; margin-top: 10px"
      >
        <el-table-column
          prop="range"
          label="金额（元）"
          align="center"
          width="120"
        >
          <template scope="scope">
            {{ scope.row.range }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="label"
          label="奖励"
          align="center"
          width="350"
        >
          <template scope="scope">
            <ShowItems :items="scope.row.reward" />
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span
              class="link-button"
              style="color: red"
              @click="remove(scope.$index)"
              >删除</span
            >
            <span
              class="link-button"
              @click="openDialog(false, scope.row, scope.$index)"
              >编辑</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import ShowItems from "./components/ShowItems";
export default {
  data() {
    return {
      data: [],
    };
  },
  components: {
    ShowItems,
  },

  watch: {
    data: {
      async handler() {
        await this.updatedParam();
      },
      deep: true,
    },
  },

  async created() {
    await this.loadConfig();
    if (this.parameter) {
      this.data = JSON.parse(this.parameter);
    }
  },

  props: {
    parameter: "",
  },

  methods: {
    async loadConfig() {},
    async openDialog(isCreated, entry, index) {
      let that = this;
      this.$dialogutil.open("EditForeverAccumulatedRechargeRebateDialog", {
        closedCallback: async (param) => {
          if (param != null) {
            if (isCreated) {
              that.data.push(param);
            } else {
              this.$set(that.data, index, param);
            }

            this.data.sort((x, y) => {
              return x.range - y.range;
            });

            await this.updatedParam();
          }
        },
        data: { isCreated, entry },
      });
    },
    async remove(index) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除金额：${this.data[index].range}元的配置？`
        );
        this.data.tasks.splice(index, 1);

        await this.updatedParam();
      } catch (error) {}
    },

    async updatedParam() {
      this.$emit("updated", JSON.stringify(this.data), async () => {
        return;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 0px 0;
}

.el-table .cell.el-tooltip {
  white-space: normal;
}
</style>